<template>
  <common-page-shell :tabs-site-nav-content="tabsSiteNavContent">
    <router-view />
  </common-page-shell>
</template>

<script>
import CommonPageShell from './CommonPageShell.vue';
import ROUTES from '@/constants/routes.constant';

export default {
  name: 'PageShellEM',
  components: {
    CommonPageShell,
  },
  data () {
    return {
      tabsSiteNavContent: [
        {
          text: 'Exchange Monitor',
          id: ROUTES.PROVIDERS_EM,
          active: false,
        },
        {
          text: 'Collection',
          id: ROUTES.COLLECTION_EM,
          active: true,
        },
        {
          text: 'History',
          id: ROUTES.HISTORY_EM,
          active: false,
        }
      ],
    };
  },
};
</script>
